export function formatWeight(value, unit) {
  if (value == null) return '';
  const num = Number(value);
  if (!isFinite(num)) return '';
  const display = Number.isInteger(num) ? num : num.toFixed(1);
  return unit ? `${display}${unit}` : `${display}`;
}
